<template>
  <div
    class="pc-header new"
    v-if="
      extras &&
      extras.groupNavbarDisplay &&
      extras.groupNavbarDisplay.display == 1
    "
    :style="{
      position:
        extras && extras.navbar && extras.navbar.browse
          ? extras.navbar.browse
          : '',
    }"
  >
    <div
      class="data-body"
      :style="{
        background:
          extras.navbarBg.colorOrBg == 'color'
            ? extras.navbarBg.color
            : 'url(' + extras.navbarBg.src + ')',
      }"
    >
      <div class="cont-left">
        <img
          v-if="extras.headerLogo.display === 1"
          :src="extras.headerLogo.src || imgUrlObj.logo"
        />
      </div>
      <div class="g-menu">
        <ul>
          <li
            v-for="(item, index) in titleItem"
            :key="index"
            :style="{
              color:
                number === item.key
                  ? extras.navbarStyle.navActive == 'custom'
                    ? extras.navbarStyle.fontColor2
                    : ''
                  : extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontColor
                  : '',
              'font-size':
                number === item.key
                  ? extras.navbarStyle.navActive == 'custom'
                    ? extras.navbarStyle.fontSize2 + 'px'
                    : ''
                  : extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontSize + 'px'
                  : '',
              'font-style':
                number === item.key
                  ? extras.navbarStyle.navActive == 'custom'
                    ? extras.navbarStyle.fontTilt2 == 'on'
                      ? 'italic'
                      : 'normal'
                    : ''
                  : extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                number === item.key
                  ? extras.navbarStyle.navActive == 'custom'
                    ? extras.navbarStyle.fontWeight2 == 'on'
                      ? 'bolder'
                      : ''
                    : ''
                  : extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'padding-right':
                (extras.navbarStyle.navActive == 'custom' &&
                  extras.navbarStyle.fontTilt2 == 'on') ||
                extras.navbarStyle.navDefault == 'custom' ||
                extras.navbarStyle.fontTilt == 'on'
                  ? '1px'
                  : '',
            }"
            v-show="extras.navText['nav' + (index + 2)] == 'show'"
            :class="{
              active: number === item.key || (isSetting == 1 && index == 0),
              'cursor-default': isSetting == 1,
            }"
            @click="
              JumpClick(
                item,
                extras.navText['linkType' + (index + 2)],
                extras.navText['anchor' + (index + 2)],
                extras.navText['link' + (index + 2)]
              )
            "
          >
            {{ extras.navText["text" + (index + 2)] }}
          </li>
        </ul>
      </div>
      <div
        class="g-right-new"
        v-show="isLogin && seminarInfo.isOpenMember != 0"
      >
        <img
          class="member-header"
          v-if="memberInfo.headImg"
          :src="memberInfo.headImg"
          @click="gotoUserCenter"
        />
        <a
          class="top-btn member-name"
          :style="{
            color:
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontColor
                : '',
            'font-size':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontSize + 'px'
                : '',
            'font-style':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
          :title="memberInfo.name"
          @click="gotoUserCenter"
          >{{ memberInfo.name }}</a
        >
        <a
          @click="logout"
          :style="{
            color:
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontColor
                : '',
            'font-size':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontSize + 'px'
                : '',
            'font-style':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
          class="top-btn"
          >退出</a
        >
      </div>
      <div>
        <div
          class="g-right-new"
          v-show="!isLogin && seminarInfo && seminarInfo.isOpenMember == 1"
        >
          <a
            :class="{
              'cursor-default': isSetting == 1,
            }"
            :style="{
              'border-color': extras.login.lineStyle,
              color:
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontColor
                  : '',
              'font-size':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontSize + 'px'
                  : '',
              'font-style':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            @click="goto('login')"
            class="top-btn"
            >登录</a
          >
          <a
            :class="{
              'cursor-default': isSetting == 1,
            }"
            :style="{
              'border-color': extras.login.lineStyle,
              color:
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontColor
                  : '',
              'font-size':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontSize + 'px'
                  : '',
              'font-style':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.navbarStyle.navDefault == 'custom'
                  ? extras.navbarStyle.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            @click="goto('register')"
            class="top-btn"
            >注册</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URLS } from "fire-wind-water";
import { goto } from "../../mixins/goto";

export default {
  name: "HeaderNew",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    loginUrl: String,
    registerUrl: String,
  },
  data() {
    return {
      isLogin: false,
      imgUrlObj: {
        logo: require("@/assets/images/logo_new.png"),
        defaultHeader: require("@/assets/images/pc/default-header.png"),
      },
      isSetting: 0,
      userCenterUrl: "",
      number: 0,
      titleItem: [
        {
          title: "大会介绍",
          key: "introduction",
          titleKey: "introductionTitle",
        },
        {
          title: "演讲嘉宾",
          key: "meetingGuest",
          titleKey: "meetingGuestTitle",
        },
        {
          title: "大会日程",
          key: "meetingAgenda",
          titleKey: "meetingAgendaTitle",
        },
        { title: "热点资讯", key: "news", titleKey: "messageTitle" },
        { title: "资料下载", key: "download", titleKey: "downloadTitle" },
        { title: "合作媒体", key: "partner", titleKey: "partnerTitle" },
      ],
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.number = "Index";
      this.isSetting = 1;
    }
  },
  mounted() {
    const { tenantId, schemaId, memberFormId } = this.seminarInfo;
    // const { usercenterUrl } = window.config;
    this.userCenterUrl = `index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    // this.userCenterUrl = `${usercenterUrl}index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (URLS.getURL("isSetting") == 1) {
      this.isLogin = false;
    }
  },
  methods: {
    goto(s) {
      switch (s) {
        case "login":
          goto.login();
          break;
        case "register":
          goto.register();
          break;
      }
    },
    gotoUrl: function (url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (url) {
        // window.$sk.goto(url);
        window.$sk.goto(url);
      }
    },
    gotoUserCenter: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      // Api.getDomain(this.seminarInfo.tenantId).subscribe((res) => {
      //   if (res.result === 0) {
      //     window.location.href = `//${res.content.domain}/usercenter/${this.userCenterUrl}`;
      //   }
      // });
      window.$sk.goto(
        `${window.$sk.config.usercenterUrl}${this.userCenterUrl}`
      );
    },
    logout: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      let r = confirm("你确定退出吗?");
      if (r == true) {
        this.isLogin = false;
        this.$emit("logout");
      }
    },
    JumpClick(item, type, anchor, link) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.number = item.key;
      if (type == "anchor") {
        this.$emit("routerEvent", { key: anchor });
      } else if (type == "link") {
        window.$sk.goto(link, true).subscribe((url) => {
          window.open(url);
        });
      }
    },
  },
};
</script>

<style scoped></style>
